import { render, staticRenderFns } from "./XXLGalleryCarousel.vue?vue&type=template&id=27794a88&"
import script from "./XXLGalleryCarousel.vue?vue&type=script&lang=js&"
export * from "./XXLGalleryCarousel.vue?vue&type=script&lang=js&"
import style0 from "./XXLGalleryCarousel.vue?vue&type=style&index=0&id=27794a88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports